import React, { Component } from 'react';
import { localize } from 'react-localize-redux';
import { Card, CardTitle, CardActions } from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import { AccentColor } from 'helpers/AccentColorHelper';

class AmenityInfo extends Component {
  render() {
    const style = {
      card: {
        color: '#424242 !important',
        fontFamily: '"Circular", sans-serif !important',
        overflow: 'hidden',
        marginTop: '15px',
      },
    };

    const amenity = this.props.amenityDetails;
    let amenityImage = amenity.image !== '/images/original/missing.png' ? amenity.image : null;

    return (
      <Card style={style.card} className="card" initiallyExpanded={true}>
        {amenityImage && <img style={{ width: '100%' }} src={amenityImage} alt="" />}
        <div
          style={{
            bottom: '1px',
            left: '1px',
            right: '1px',
            background: 'white',
            borderRadius: '8px',
          }}
        >
          <CardTitle
            title={amenity.name}
            subtitle={amenity.description}
            style={{ padding: '15px' }}
            titleStyle={{ fontFamily: 'Circular-Black' }}
          />
          {amenity.bookable && (
            <CardActions style={{ textAlign: 'center', padding: '0 15px 15px' }}>
              <FlatButton
                label={this.props.translate('book')}
                onClick={() => this.props.openBookingDialog(amenity)}
                primary={true}
                backgroundColor={AccentColor()}
                hoverColor="grey"
                fullWidth
                style={{
                  color: 'white',
                  height: '40px',
                  margin: 'auto',
                }}
                tabIndex="1"
              />
            </CardActions>
          )}
        </div>
      </Card>
    );
  }
}

export default localize()(AmenityInfo);
